import { Typography } from '@shared/Typography';
import styles from './AdvantagesHeader.module.scss';

const CUP_IMAGES = [
  '/images/referralCups/greenCup.webp',
  '/images/referralCups/redCup.webp',
  '/images/referralCups/blueCup.webp',
  '/images/referralCups/purpleCup.webp',
  '/images/referralCups/cyanCup.webp',
];

export const AdvantagesHeader = () => {
  return (
    <>
      <div className={styles.ahWrapper}>
        <div>
          <img src="/images/logo.webp" width={37} height={32} alt="logo" />
        </div>
        <div className={styles.ahCupRow}>
          <Typography component="description2">
            EARN <span className={styles.goldText}>1%</span> FROM ALL YOUR{' '}
            <span className={styles.goldText}>FRIENDS</span> BETS!
          </Typography>
          <div className={styles.cupRow}>
            {CUP_IMAGES.map((src, index) => (
              <img
                key={index}
                src={src}
                alt={`cup-${index + 1}`}
                width={24}
                height={24}
                className={styles.cupImage}
              />
            ))}
          </div>
          <Typography component="description2">5 level partner program</Typography>
        </div>
      </div>
    </>
  );
};
